import ReactDOMServer from "react-dom/server";
import React from "react";

export const handlePrint = (content: any) => {
  console.log(content);

  const printContent = ReactDOMServer.renderToStaticMarkup(
    <html>
      <head>
        <meta http-equiv="Content-Type" content="text/html;charset=UTF-8" />
        <title>
          {content?.props?.data?.id
            ? `Receipt ${content?.props?.data?.id}`
            : "Receipt"}
        </title>
        <link rel="preconnect" href="https://fonts.googleapis.com"></link>
        <link rel="preconnect" href="https://fonts.gstatic.com"></link>
        <link
          href="https://fonts.googleapis.com/css2?family=Cairo:wght@200..1000&display=swap"
          rel="stylesheet"
        ></link>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css"
        />
        <style dangerouslySetInnerHTML={{__html: `
  @media print {
    @page {
      margin: 0; /* Adjust the margin as needed */
      size: auto; /* it might be necessary to manage the print size manually */
    }
    .header, .footer, #header, #footer, .page-header, .page-footer { 
      display: none !important;
    }
    body {
      margin: 0.5cm; /* Adjust based on how much margin you need */
    }
  }
`}} />

      </head>

      <body style={{ fontFamily: "Cairo, Arial, sans-serif" }}>
        <div>{content}</div>
        <div
          style={{
            backgroundColor: "#00086D",
            color: "#B0B0C0",
            colorAdjust: 'exact',
            WebkitPrintColorAdjust: "exact",
            padding: "1rem",
            textAlign: "center",
            fontWeight: "lighter",
            fontSize: "14px",
          }}
          dir="rtl"
          className="w-full flex items-center cursor-pointer gap-2 justify-center text-center"
        >
          <span className="text-xs font-normal" style={{ color: "#B0B0C0" }}>
            مقدم من قبل
          </span>
          <span className="bg-slate-600">
            <svg
              width="86"
              height="19"
              viewBox="0 0 86 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6367 13.0073C13.6367 9.86474 15.8607 7.58984 18.9167 7.58984C21.9726 7.58984 24.1966 9.86474 24.1966 13.0073C24.1966 16.1499 21.9726 18.4248 18.9167 18.4248C15.8607 18.4248 13.6367 16.1505 13.6367 13.0073ZM18.9167 15.654C20.2473 15.654 21.2033 14.5359 21.2033 12.9866C21.2033 11.4374 20.2473 10.3193 18.9167 10.3193C17.5861 10.3193 16.63 11.4374 16.63 12.9866C16.63 14.5359 17.5844 15.654 18.915 15.654H18.9167Z"
                fill="white"
              />
              <path
                d="M24.3555 13.0073C24.3555 9.86474 26.5795 7.58984 29.6354 7.58984C32.6914 7.58984 34.9154 9.86474 34.9154 13.0073C34.9154 16.1499 32.6908 18.4248 29.6354 18.4248C26.5801 18.4248 24.3555 16.1505 24.3555 13.0073ZM29.6354 15.654C30.9655 15.654 31.9221 14.5359 31.9221 12.9866C31.9221 11.4374 30.9655 10.3193 29.6354 10.3193C28.3054 10.3193 27.3488 11.4374 27.3488 12.9866C27.3488 14.5359 28.3048 15.654 29.6354 15.654Z"
                fill="white"
              />
              <path
                d="M38.5713 4.38477V11.8284L41.6462 8.10656H45.3898L41.6272 12.2007L45.8058 18.4451H42.2277L39.6939 14.2889L38.5713 15.5093V18.4451H35.6641V4.38477H38.5713Z"
                fill="white"
              />
              <path
                d="M46.8143 7.62917V4.25624C46.8143 2.16808 48.3524 0.617188 50.431 0.617188C51.2423 0.617188 52.1983 0.844733 52.801 1.19584L51.9696 3.75978C51.7203 3.57416 51.2629 3.42936 50.8884 3.42936C50.2236 3.42936 49.7243 3.92527 49.7243 4.58722V7.62917H55.8927V10.1931H49.7243V18.4457H46.8171V10.1931H45.2344V7.62917H46.8143Z"
                fill="white"
              />
              <path
                d="M55.8637 10.7148V18.4436H52.9531V10.7148H55.8637Z"
                fill="white"
              />
              <path
                d="M62.1142 10.6697C60.929 10.6697 60.0356 11.7242 60.0356 13.1509V18.4443H57.125V8.10468H59.3747L59.9981 9.71762C60.4974 8.62127 61.8274 7.85645 63.1994 7.85645C65.3407 7.85645 66.8167 9.73831 66.8167 12.3229V18.4443H63.9033V12.82C63.9033 11.5587 63.1765 10.6697 62.1142 10.6697Z"
                fill="white"
              />
              <path
                d="M67.3789 12.972C67.3789 9.84959 69.3541 7.51319 71.9941 7.51319C72.5506 7.50663 73.102 7.61953 73.6112 7.84425C74.1203 8.06897 74.5753 8.40029 74.9455 8.81585V4.03906H77.8561V16.0319L77.8974 18.3482H75.6108L75.1328 16.818C74.3635 17.7896 73.2828 18.3482 71.9941 18.3482C69.3748 18.3482 67.3789 16.0319 67.3789 12.972ZM72.6594 15.5388C73.9895 15.5388 74.9455 14.443 74.9455 12.9111C74.9455 11.3792 73.9895 10.2834 72.6594 10.2834C71.3294 10.2834 70.3722 11.3798 70.3722 12.9111C70.3722 14.4424 71.3288 15.5388 72.6594 15.5388Z"
                fill="white"
              />
              <path
                d="M79.1032 8.1048H81.3485L81.9076 9.59363C82.427 8.49783 83.3003 7.85657 84.4234 7.85657C84.7982 7.85275 85.1686 7.93782 85.5042 8.1048L85.0055 11.2066C84.8182 11.1238 84.4855 11.0825 84.1735 11.0825C82.9055 11.0825 82.0121 11.9507 82.0121 13.2327V18.4433H79.1016L79.1032 8.1048Z"
                fill="white"
              />
              <path
                d="M1.76409 18.3494L0.496094 15.701C1.63975 15.1588 2.72088 14.4935 3.72031 13.7169C3.10518 12.6624 2.79709 11.4569 2.83081 10.2366C2.87442 8.20433 3.44133 6.06864 4.42811 4.22144C5.13199 2.9048 6.57386 1.19066 8.32322 0.69979C8.79165 0.56213 9.28343 0.522509 9.76786 0.583399C10.2523 0.644289 10.719 0.804383 11.1388 1.05369C11.9215 1.51102 12.4386 2.3597 12.5605 3.38114C12.8412 5.74884 12.1965 8.4397 10.0564 11.5146C9.40766 12.4254 8.70415 13.2958 7.94976 14.1211C9.44362 15.5747 10.8011 15.9906 12.7791 15.5031L13.195 18.0967C10.5249 18.7978 7.51759 17.7495 5.72238 15.8827C4.50162 16.8536 3.17351 17.6813 1.76409 18.3494ZM9.32957 3.4896C9.25867 3.49078 9.18829 3.50188 9.12047 3.52259C8.39758 3.72553 7.49019 4.73691 7.03063 5.59789C6.26748 7.02634 5.81071 8.73992 5.77717 10.2986C5.76402 10.7475 5.83104 11.195 5.97508 11.6203C6.463 11.0791 6.91655 10.5079 7.33309 9.91008C9.0271 7.47808 9.82044 5.34072 9.62532 3.72777C9.61885 3.66742 9.60379 3.6083 9.58059 3.55222C9.50296 3.51201 9.41699 3.49056 9.32957 3.4896Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
      </body>
    </html>
  );

  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  document.body.appendChild(iframe);

  const printWindow = iframe.contentWindow;
  if (printWindow) {
    printWindow.document.write(printContent);
    printWindow.document.close();
    setTimeout(() => {
      printWindow.print();
      document.body.removeChild(iframe);
    }, 500); // Delay printing to ensure page numbers are displayed correctly
  } else {
    // Handle error
    alert("Failed to open print window.");
  }
};
